import React from 'react'
import SettingsMetaData from '../../../../../Components/Hooks/useSettingsMetaData'

function Brand() {
  return (
    <SettingsMetaData propertyName={"brand_equipments"} viewPropertyName={"Brand"} />

  )
}

export default Brand